module.exports = __webpack_public_path__ + "static/media/right-arrow.d719aa32.svg";